export default {
  API_ERROR: "Lamentamos, algo correu mal. Por favor, tente novamente.",
  FORM_ERROR: "Lamentamos, mas precisa de escrever um pouco mais para partilhar o seu feedback connosco."
}